// Print-DPI re-bake registry — the shared seam that lets the export pre-pass
// (exportUtils) re-bake ANY recipe image at print resolution without hardcoding
// a tool list. Both text3d and emboss-text flow through it.
//
// Deliberately a PLAIN registry: it imports nothing heavy (no fabric, no three)
// so it is safe on the editor boot chunk. Registration lives with the export
// hook, which supplies LAZY bake wrappers — the actual recipe modules load
// only when a bake runs.
//
// Registry entry contract:
//   registerBaker(tool, {
//     bake:  (params, { targetPx }) => Promise<{ dataUrl }>,  // lazy-imports its recipe
//     maxPx: number,                                          // hard ceiling for a print bake
//   })

const BAKE_REGISTRY = new Map();

/**
 * Register (or replace) the print-DPI baker for a `data.tool`.
 * @param {string} tool
 * @param {{ bake: Function, maxPx?: number }} entry
 */
export function registerBaker(tool, { bake, maxPx } = {}) {
  if (!tool || typeof bake !== 'function') return;
  BAKE_REGISTRY.set(tool, { bake, maxPx: Number(maxPx) || 4096 });
}

/** The baker registered for `tool`, or null. */
export function getBaker(tool) {
  return (tool && BAKE_REGISTRY.get(tool)) || null;
}

export { BAKE_REGISTRY };
